import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { SEO_SICILIA } from "@/data/seoSicilia";
import { useLang } from "@/i18n";

// Home "Leggi di più": the full text is always in the page (Google reads it); only its height is folded.
const Block = ({ b: [h, ps, items] }) => (
  <div className="mt-8">
    {h && <h3 className="font-display text-xl font-bold tracking-tight sm:text-2xl">{h}</h3>}
    {ps.map((p) => <p key={p.slice(0, 24)} className="mt-3 text-sm leading-relaxed text-[#3D3833] sm:text-base">{p}</p>)}
    {items.length > 0 && (
      <ul className="mt-3 space-y-2 text-sm leading-relaxed text-[#3D3833] sm:text-base">
        {items.map(([k, v]) => <li key={k} className="border-l-2 border-[#C26D38] pl-4"><b className="text-[#121110]">{k}:</b> {v}</li>)}
      </ul>
    )}
  </div>
);

export const SeoSicilia = () => {
  const { lang } = useLang();
  const s = SEO_SICILIA[lang] ?? SEO_SICILIA.it;
  const [open, setOpen] = useState(false);
  return (
    <section id="sicilia" className="bg-[#F7F5F0] px-5 py-20 text-[#121110] sm:px-8 lg:py-28" data-testid="seo-sicilia">
      <div className="mx-auto max-w-4xl">
        <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">{s.title}</h2>
        <p className="mt-5 text-base leading-relaxed text-[#3D3833] sm:text-lg">{s.intro}</p>
        <div id="sicilia-more" className={`relative overflow-hidden transition-[max-height] duration-700 ease-out ${open ? "max-h-[4000px]" : "max-h-0"}`} aria-hidden={!open} data-testid="seo-sicilia-more">
          {s.blocks.map((b, i) => <Block key={i} b={b} />)}
        </div>
        <button onClick={() => setOpen(!open)} aria-expanded={open} aria-controls="sicilia-more" className="tap mt-8 inline-flex items-center gap-2 rounded-full border border-[#121110]/25 px-6 py-3 font-mono text-xs uppercase tracking-[0.16em] transition-colors duration-300 hover:border-[#C26D38] hover:text-[#9A5326]" data-testid="seo-sicilia-toggle">
          {open ? s.less : s.more} <ChevronDown className={`h-4 w-4 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
        </button>
      </div>
    </section>
  );
};
